/**
 * FiberList Component - Display fiber assignments for selected cable
 */
import React from 'react';
import { Cable, FiberAssignment } from '../../types';
import { getFiberBadgeStyle } from '../../utils/colorUtils';
import './FiberList.css';

interface FiberListProps {
  cable: Cable;
}

export const FiberList: React.FC<FiberListProps> = ({ cable }) => {
  const getFiberColorStyle = (color: string): React.CSSProperties => {
    return getFiberBadgeStyle(color);
  };

  const usedFibers = cable.fiber_assignments.filter((f) => f.is_used).length;
  const freeFibers = cable.fiber_assignments.length - usedFibers;

  return (
    <div className="fiber-list">
      <div className="fiber-list-header">
        <h4>Priradenie vlákien</h4>
        <div className="fiber-stats">
          <span className="fiber-stat-used">{usedFibers} used</span>
          <span className="fiber-stat-free">{freeFibers} free</span>
        </div>
      </div>

      <div className="fiber-items">
        {cable.fiber_assignments.map((fiber: FiberAssignment) => (
          <div
            key={fiber.fiber_number}
            className={`fiber-item ${fiber.is_used ? 'used' : 'free'}`}
          >
            <div className="fiber-number">#{fiber.fiber_number}</div>
            <div
              className="fiber-color"
              style={getFiberColorStyle(fiber.color)}
            >
              {fiber.color}
            </div>
            <div className="fiber-status">
              {fiber.is_used ? (
                <span className="status-used">
                  ✓ Used {fiber.used_by_pole_id && `(Pole #${fiber.used_by_pole_id})`}
                </span>
              ) : (
                <span className="status-free">○ Free</span>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

